import { render, staticRenderFns } from "./MinTable.vue?vue&type=template&id=e2d3c1a4&"
import script from "./MinTable.vue?vue&type=script&lang=js&"
export * from "./MinTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports